import { useQuery } from 'react-query';
import BattlesService, { HallOfFameDateLimit } from 'services/battles/BattlesService';

export type UseGetHallOfFameProps = {
	'services.battlesService': BattlesService;
	limit: HallOfFameDateLimit;
};

export type UseGetHallOfFameQueryReturn = ReturnType<typeof useGetHallOfFame>;

export const useGetHallOfFame = (props: UseGetHallOfFameProps) => {
	const battlesService = props['services.battlesService'];
	return useQuery({
		queryKey: ['battles-hall-of-fame', props.limit],
		queryFn: () => battlesService.fetchHallOfFame(props.limit),
	});
};

export default useGetHallOfFame;
